module.exports = __webpack_public_path__ + "img/dashboardArrow.b6538e58.svg";